import { render } from "./wangeditorInfoComp.vue?vue&type=template&id=6f069810&scoped=true"
import script from "./wangeditorInfoComp.vue?vue&type=script&lang=js"
export * from "./wangeditorInfoComp.vue?vue&type=script&lang=js"

import "./wangeditorInfoComp.vue?vue&type=style&index=0&id=6f069810&scoped=true&lang=css"

import exportComponent from "F:\\workspace_2022\\ZhaiJiDi\\QT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f069810"]])

export default __exports__